import DOMPurify from 'dompurify';
import { UserDto } from './wemble-api.generated';

/**
 * A firm's custom Home-page HTML (Company.customHtml, firms with `enableCustomHtml`) for this user:
 * the USER_* placeholders filled in, then sanitised, since a company admin wrote it and every
 * colleague's browser renders it. Keeps tags, inline styles, <style> blocks and links (with their
 * target); drops scripts, event handlers and javascript: URLs.
 */
export function renderCustomHtml(html: string, user: UserDto): string {
  const filled = html
    .replaceAll('USER_NAME', user.name || '')
    .replaceAll('USER_CUSTOM_ID', user.name?.toLowerCase().replaceAll(' ', '-') || '')
    .replaceAll('USER_EMAIL', user.email || '')
    .replaceAll('USER_WEMBLE_ID', user._id || '')
    .replaceAll('USER_PHOTO_URL', user.profilePicture ? 'https://d378wr66tg5qg7.cloudfront.net/' + user.profilePicture : '');
  // FORCE_BODY keeps a leading <style> block (otherwise the parser moves it into <head> and it's dropped).
  return DOMPurify.sanitize(filled, { FORCE_BODY: true, ADD_ATTR: ['target'] });
}
